import React, {Suspense} from 'react';
import {Alert, Spin} from 'antd';
import EventForm, {EventFormActions} from '../panels/EventForm';
import FinancialDetails from '../panels/FinancialDetails';
import EventActivity from '../panels/EventActivity';
import EventApproval from '../panels/EventApproval';

interface EventDetailNavigationProps {
  eventId?: string;
  activePanel: string;
  onRegisterActions?: (actions: EventFormActions) => void;
  onSavingChange?: (saving: boolean) => void;
}

const EventDetailNavigation: React.FC<EventDetailNavigationProps> = ({
  eventId,
  activePanel,
  onRegisterActions,
  onSavingChange,
}) => {
  const commonProps = {eventId, activePanel};

  const renderPanel = () => {
    switch (activePanel) {
      case 'event-form':
        return (
          <EventForm
            {...commonProps}
            onRegisterActions={onRegisterActions}
            onSavingChange={onSavingChange}
          />
        );
      case 'event-financial':
        return <FinancialDetails {...commonProps}/>;
      case 'event-activity':
        return <EventActivity {...commonProps}/>;
      case 'event-approval':
        return <EventApproval {...commonProps}/>;
      default:
        return (
          <Alert
            message="Panel not found"
            description={`Panel "${activePanel}" could not be found.`}
            type="warning"
            showIcon
          />
        );
    }
  };

  return (
    <Suspense
      fallback={
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400}}>
          <Spin size="large"/>
        </div>
      }
    >
      {renderPanel()}
    </Suspense>
  );
};

export default EventDetailNavigation;
